import React, { useEffect, useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Dropdown = ({ toggle, setToggle, option, optionPlaceholder, children }) => {
  const modalRef = useRef(null);
  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setToggle(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="relative">
      <button
        onClick={() => setToggle((prev) => !prev)}
        className={`rounded-full cursor-pointer ring-1 ${ toggle ? 'ring-slate-500' : 'ring-gray-200'} w-40 h-10 flex items-center justify-between px-4`}
      >
        <span>{option || optionPlaceholder || ''}</span>
        {toggle ? <FaChevronUp /> : <FaChevronDown />}
      </button>
      {toggle ? (
        <ul
          ref={modalRef}
          className="absolute w-56 rounded-md ring-1 ring-gray-200 top-12 bg-white z-50 flex flex-col"
        >
          {children}
        </ul>
      ) : null}
    </div>
  );
};

export default Dropdown;
